export const editPermissionDenyMessage = 'You don’t have permission to edit this pipeline'
